<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    :header="$t('user_manage.edit_user')"
    :style="{ width: '500px' }"
    @hide="$emit('close')"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded">
      <div class="space-y-4">
        <div class="field flex flex-col">
          <label for="firstname" class="mb-1">{{ $t('user_manage.first_name') }}</label>
          <InputText
            id="firstname"
            v-model="localUserData.firstname"
            :placeholder="$t('user_manage.first_name')"
          />
        </div>
        <div class="field flex flex-col">
          <label for="lastname" class="mb-1">{{ $t('user_manage.last_name') }}</label>
          <InputText
            id="lastname"
            v-model="localUserData.lastname"
            :placeholder="$t('user_manage.last_name')"
          />
        </div>
      </div>
      <div class="space-y-4">
        <div class="field flex flex-col">
          <label for="email" class="mb-1">{{ $t('user_manage.email') }}</label>
          <InputText
            id="email"
            v-model="localUserData.email"
            :placeholder="$t('user_manage.email')"
          />
        </div>
        
       <div class="space-y-4">
         <div class="field flex flex-col">
          <label for="service" class="mb-1">{{ $t('user_manage.service') }}</label>
          <Dropdown
            id="service"
            v-model="localSelectedServiceId"
            :options="services"
            option-label="name"
            option-value="id"
            :placeholder="$t('user_manage.select_service')"
          />
        </div>
       </div>
      </div>
      
      <div class="space-y-4">
        <div class="field">
          <label for="phone">{{ $t('user_manage.phone') }}</label>
          <PhoneInput
            v-model="localUserData.phone"
            :placeholder="$t('user_manage.phone')"
          />
        </div>
      </div>
    </div>
    
    <template #footer>
      <Button
        :label="$t('common.cancel')"
        icon="pi pi-times"
        class="p-button-text primary-text"
        @click="$emit('close')"
        
      />
      <Button
        :label="$t('common.save')"
        icon="pi pi-check"
        @click="handleSave"
        class="spect-btn-primary"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from 'vue'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import PhoneInput from '@/components/PhoneInput.vue'

const props = defineProps({
  visible: Boolean,
  userData: Object,
  services: Array,
  selectedServiceId: [String, Number]
})

const emit = defineEmits(['update:visible', 'save', 'close', 'update:selectedServiceId'])

// Create local reactive copies of props
const localUserData = ref({})
const localSelectedServiceId = ref(null)

// Watch for prop changes and update local data
watch(() => props.userData, (newData) => {
  if (newData) {
    localUserData.value = { ...newData }
  }
}, { immediate: true, deep: true })

watch(() => props.selectedServiceId, (newId) => {
  localSelectedServiceId.value = newId
}, { immediate: true })

// Watch local service ID changes and emit to parent
watch(localSelectedServiceId, (newId) => {
  emit('update:selectedServiceId', newId)
})

const localVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
})

const handleSave = () => {
  // Emit the save event with the local data
  emit('save', {
    userData: localUserData.value,
    serviceId: localSelectedServiceId.value
  })
}
</script>
<style lang="scss" scoped>
@use "../../assets/scss/variables.scss" as *;
@use "../../assets/scss/app/common.scss" as *;
</style>